import { RootState } from 'editor/src/store/index';
import { isEmbedded } from 'editor/src/store/watchers/useDisplayMode';

import getCustomerUploadedFonts from './getCustomerUploadedFonts';

/**
 * GAPI-61790: whether the customer's font picker shows only the tenant's uploaded fonts.
 *
 * The template author turns it on per template (Customer settings → "Use only uploaded
 * fonts"); it applies only in the embedded customer editor, never to the author. While the
 * tenant has no usable uploaded font it stays off, so the picker is never left empty. It
 * only narrows what the picker offers: the bundled fonts stay loaded, so text that already
 * uses one keeps rendering.
 */
function isOnlyUploadedFonts(state: RootState) {
  return (
    isEmbedded &&
    !!state.design.designData?.personalizationSettings?.onlyUploadedFonts &&
    getCustomerUploadedFonts(state).length > 0
  );
}

export default isOnlyUploadedFonts;
